import { testimonyRepository } from "../../../providers/repositories/testimonyRepository";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";
import { TestimonyFormData } from "../entities/Testimony";

export const addUpdateTestimonyUseCase = {
    async exec(
        data: TestimonyFormData,
        id: number | string | null,
    ): Promise<boolean> {
        try {
            await testimonyRepository.addUpdate(data, id);

            if (id) {
                toast.success(t("action.updateSuccess"));
            }
            return true;
        } catch (error) {
            Logger.error("updateTestimonyUseCase", error);
            toast.error(t("action.updateError"));
        }
        return false;
    },
};
